export default function EditTrainingDocumentDirectiveController(
  $q,
  $scope
) {
  const vm = this;
  const trainingAdminDocumentNameLength = 255;
  // vm.newMediaInputs = {};
  vm.newMediaInputs.progress = 0;

  vm.handleDocumentFileAdd = _handleDocumentFileAdd;
  vm.handleDocumentFileValidate = _handleDocumentFileValidate;

  // eslint-disable-next-line no-unused-vars
  function _handleDocumentFileAdd($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {
    vm.newMediaInputs.fileName = $file.name;
    vm.media.contentId = undefined;
    vm.newMediaInputs.progress = 0;
  }

  function _handleDocumentFileValidate($file) {
    let isValid = true;
    if ($file.name.indexOf('&') > -1) {
      $scope.editMediaDocumentForm.documentFile.$setValidity('specialCharacters', false);
      isValid = false;
    } else {
      $scope.editMediaDocumentForm.documentFile.$setValidity('specialCharacters', true);
    }
    if ($file.name.length > trainingAdminDocumentNameLength) {
      $scope.editMediaDocumentForm.documentFile.$setValidity('nameLength', false);
      isValid = false;
    } else {
      $scope.editMediaDocumentForm.documentFile.$setValidity('nameLength', true);
    }

    return isValid;
  }
}


EditTrainingDocumentDirectiveController.$inject = [
  '$q',
  '$scope',
];
